import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth';
import 'vue-router'
import { useNavigationGuardStore } from '@/stores/navigationGuard'

let authStore;

// Extend the RouteMeta interface
declare module 'vue-router' {
  interface RouteMeta {
    position?: number
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'races',
      component: () => import('../views/RacesView.vue'),
      meta: {
        requiresAuth: true,
        position: 1,
      },
      children: [
        {
          path: '',
          name: 'index',
          component: () => import('../views/races/IndexView.vue'),
          meta: { position: 1 }
        },
        {
          path: '/races/:id',
          name: 'show',
          component: () => import('../views/races/ShowView.vue'),
          meta: { position: 2 }
        },
        {
          path: '/races/:raceId/people/:personId',
          name: 'person',
          component: () => import('../views/races/people/ShowView.vue'),
          meta: { position: 3 }
        },
        {
          path: '/races/:id/manage',
          name: 'manage-race',
          component: () => import('../views/races/ManageRaceView.vue'),
          meta: {
            position: 3,
            requiresAuth: true
          }
        },
      ],
    },
    //{
    //  path: '/about',
    //  name: 'about',
    //  // route level code-splitting
    //  // this generates a separate chunk (About.[hash].js) for this route
    //  // which is lazy-loaded when the route is visited.
    //  component: () => import('../views/AboutView.vue'),
    //},
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    }
  ],
})

router.beforeEach(async (to, from, next) => {
  authStore ||= useAuthStore();
  const guardStore = useNavigationGuardStore();

  // Check authentication first
  if (to.meta.requiresAuth) {
    await authStore.init()
    if (!authStore.authenticated) {
      await authStore.storeLocation(to)
      return next({ path: '/login' })
    }
  }

  // Check navigation guards
  const canNavigate = await guardStore.checkGuards()
  if (!canNavigate) {
    // Abort navigation
    return next(false)
  }

  return next()
})

export default router
